import type { ReactNode } from "react";

export type StateBadgeTone = "neutral" | "info" | "warning" | "success" | "error" | "muted";

interface Props {
  label: string;
  tone: StateBadgeTone;
  icon?: ReactNode;
  title?: string;
}

const TONE_CLASSES: Record<StateBadgeTone, string> = {
  neutral: "bg-card-hover text-text-primary ring-1 ring-ring",
  info: "bg-info-bg text-info",
  warning: "bg-warning-bg text-warning",
  success: "bg-success-bg text-success",
  error: "bg-error-bg text-error",
  muted: "bg-card-hover text-text-muted",
};

export function StateBadge({ label, tone, icon, title }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${TONE_CLASSES[tone]}`}
      title={title}
    >
      {icon}
      {label}
    </span>
  );
}
